import React from 'react';
import { useActiveSection } from '../../hooks/useActiveSection';
interface ArticleTocProps {
  items: {
    id: string;
    label: string;
  }[];
}

// Sticky "On this page" list. The current section is marked with an orange rule.
export function ArticleToc({
  items
}: ArticleTocProps) {
  const active = useActiveSection(items.map(item => item.id), 140);
  function jump(event: React.MouseEvent<HTMLAnchorElement>, id: string) {
    const el = document.getElementById(id);
    if (!el) return;
    event.preventDefault();
    const top = el.getBoundingClientRect().top + window.scrollY - 110;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top,
      behavior: reduce ? 'auto' : 'smooth'
    });
    history.replaceState(null, '', `#${id}`);
  }
  return <nav aria-label="On this page" data-id="element-89" data-mp="d9uaxvy94y0r">
      <p className="type-label text-muted" data-id="element-90" data-mp="danc8hefyvbi">On this page</p>
      <ol className="mt-4 space-y-1 border-l-2 border-line" data-id="element-91" data-mp="ha4ive5ltyi9">
        {items.map(item => {
        const current = item.id === active;
        return <li key={item.id} data-id="element-92" data-mp="22tip9vox7akb">
              <a href={`#${item.id}`} onClick={event => jump(event, item.id)} aria-current={current ? 'true' : undefined} className={`-ml-[2px] block border-l-2 py-1.5 pl-4 type-small transition-colors duration-150 ${current ? 'border-brand font-bold text-ink' : 'border-transparent text-body hover:text-ink'}`} data-id="element-93" data-mp="1y0fr1a977cxs">
                {item.label}
              </a>
            </li>;
      })}
      </ol>
    </nav>;
}